import React, { useContext } from "react";
import { Button, Container, Input, Label } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import { CartContext } from "../../Context/CartContext";
import { validateInput } from "../../helpers/formHandlers";

const custBttn = css`
  font-size: 1.75vh;
`;
const inputStyle = css`
  font-size: 1.5vh;
  width: 5vh;
  height: 3vh;
  text-align: center;
  padding: 0.5vh;
  border-radius: 12px;
`;

const ProductQuantity = ({
  product,
  quantityFrom = "context",
  localQuantity,
  setLocalQuantity,
}) => {
  const { changeProductQuantity, addToCart, removeFromCart } =
    useContext(CartContext);

  const onChangeProdQuantity = (e) => {
    const { value } = e.target;

    const inputProps = {
      type:"number",
      value: value,
      min: 1,
      max: 999,
      integer: true,
      required: true,
    };

    //to be retested with new validator
    const hasError = validateInput(inputProps);
    if (hasError) return;

    if (quantityFrom === "context") {
      changeProductQuantity(product._id, value);
    } else {
      setLocalQuantity(value);
    }
  };

  const decreaseQuantity = () => {
    if (quantityFrom === "context") {
      removeFromCart(product._id);
    } else {
      setLocalQuantity((prev) => Math.max(1, parseInt(prev) - 1));
    }
  };

  const increaseQuantity = () => {
    if (quantityFrom === "context") {
      addToCart(product, 1);
    } else {
      setLocalQuantity((prev) => Math.min(999, parseInt(prev) + 1));
    }
  };

  const quantityValue =
    quantityFrom === "context" ? product?.cartQuantity || 0 : localQuantity;

  return (
    <Container>
      <Label>Quantity</Label>
      <Button $baseStyle={custBttn} onClick={decreaseQuantity}>
        -
      </Button>
      <Input
        $baseStyle={inputStyle}
        value={quantityValue}
        onChange={onChangeProdQuantity}
      />
      <Button $baseStyle={custBttn} onClick={increaseQuantity}>
        +
      </Button>
    </Container>
  );
};

export default ProductQuantity;
